import Model from 'src/app/common/model';
import CultureCategory from './cultureCategory.model';
import SpeciesTypeModel from './speciesType.model';
import CustomerPondModel from './customerPond.model';
import CultureTypeModel from './cultureType.model';
import FarmSiteModel from './farmSite.model';
import WaterTypeModel from './waterType.model';
import SoilTypeModel from './soilTypeModel';

export default class PondCultureModel extends Model {
  cultureCategory: CultureCategory;
  speciesType: SpeciesTypeModel;
  pond: CustomerPondModel;
  cultureType: CultureTypeModel;
  FarmSiteDetails: Array<FarmSiteModel>;
  traceability?: Array<Traceability>;
  waterType: WaterTypeModel;
  soilType: SoilTypeModel;
  culture_category_id?: number;
  water_type_id?: number;
  soil_type_id?: number;
  species_type_id?: number;
  stocking_density: number;
  pond_culture_age?: number;
  start_date?: string;
  end_date?: Date;
  stocking_size?: number;
  stocking_count?: number;
  produce_size?: number;
  produce_count?: number;
  stage?: string;
  pond_id: string;
  bonus_count?: number;
  bonus_size?: number;
  culture_type_id: number;
  date_of_stocking: Date;
  time_of_stocking: Date;
  pl_size?: string;
  name_of_the_hatchery?: string;
  salinity_of_stocking?: number;
  present_no_of_animals?: number;
  remarks?: Text;
  manualClose: boolean;
  name: string;
  pond_identifier: string;
  pond_name: string;
  isPreparatory: boolean;
  business_id: string;
  farm_site_id: string;
  section_id?: string;
  DOC?: number;
  doc: number;
  date: string;
  Date: string;
  section_name?: string;
  Tank?: string;
  Area?: number;
  pondtypeid?: number
  StockingDensity?: number;
  Meal1?: string;
  Checktray1?: string;
  Checktraygiven1?: string;
  Meal2?: string;
  Checktray2?: string;
  Checktraygiven2?: string;
  Meal3?: string;
  Checktraygiven3?: string;
  Checktray3?: string;
  Meal4?: string;
  Checktraygiven4?: string;
  Checktray4?: string;
  FeedQuantity?: number;
  feedDayCost?: string;
  cumulative_feed?: number;
  CummulativeTreatment?: number;
  treatCumulativeCost?: number;
  feedCumulativeCost: number;
  TreatQuantity: string;
  TreatmentData: string;
  treatDayCost: number;
  survival_rate: number;
  abw: number;
  Biomass: string;
  mintemperature: number;
  maxtemperature: number;
  filePath: string;
  pond_culture_id?: string | number;
  businessName: string;
  sectionName: string;
  farmSiteName: string;
  pondName?: string;
  culture_identifier: string;
  cultureName?: string;
  cultureStarted?: Date;
  cultureEnded?: Date;
  CummulativefeedDetails?: string;
  CummulativetreatmmentDetails?: string;
  Totalcost?: number;
  Density: number;
  pond_size: number;
  water_volume: number;
  farmNameAtLocation: string;
  person_id: string;

  constructor() {
    super();
  }
}

//////////////////////////////
//Traceability
//////////////////////////////
export class Traceability {
  pondName?: string;
  Dates?: Date;
  feedQuantitydetails?: string;
  treatmentQuantitydetails?: string;
  Observation?: string;
  samplingdetails?: string;
  Harvestdetails?: string;
  CummulativefeedDetails?: string;
  CummulativetreatmmentDetails?: string;
  cost?: number;
  Totalcost?: number;
  weather: string;

  constructor() { }
}
